import { render, staticRenderFns } from "./Powered.vue?vue&type=template&id=96fbd87a&scoped=true"
import script from "./Powered.vue?vue&type=script&lang=js"
export * from "./Powered.vue?vue&type=script&lang=js"
import style0 from "./Powered.vue?vue&type=style&index=0&id=96fbd87a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96fbd87a",
  null
  
)

export default component.exports